import { createSlice } from "@reduxjs/toolkit";
import { GitBranch, Network, Users } from "lucide-react";

export type UserTabType =
  | "Role Management"
  | "User Management"
  | "Branch Management";

export interface Tab {
  label: UserTabType;
  Icon: typeof Network | typeof Users | typeof GitBranch;
  value: UserTabType;
}

export const userTabs: Tab[] = [
  {
    label: "Role Management",
    Icon: Network,
    value: "Role Management",
  },
  {
    label: "User Management",
    Icon: Users,
    value: "User Management",
  },
  {
    label: "Branch Management",
    Icon: GitBranch,
    value: "Branch Management",
  },
];

export const currentUserDefaultValues = {
  name: "",
  email: "",
  phone: "",
  roleId: "",
  branches: [],
  customFieldAccess: [] as number[],
  // Values of the custom fields shown on Users (Team…) — same shape the lead
  // form sends: one entry per field, options or text.
  customInputScopes: [] as Array<{
    customInputId: number;
    optionIds?: number[];
    textValue?: string | null;
  }>,
  teleCmiId: "",
  // "Team lead": sees the My team dashboard card for their own team.
  isTeamLead: false,
  password: "",
  confirmPassword: "",
  isActive: true,
  avatar: "",
};

export interface UserState {
  isAddUser: boolean;
  isDeleteUser: boolean;
  isEditUser: boolean;
  currentTab: UserTabType;
  userId: number | undefined;
}

const initialState: UserState = {
  isAddUser: false,
  isDeleteUser: false,
  isEditUser: false,
  currentTab: "Role Management",
  userId: undefined,
};

const userSlice = createSlice({
  name: "user-functional",
  initialState,
  reducers: {
    setIsAddUser(state, action) {
      state.isAddUser = action.payload;
    },
    setIsDeleteUser(state, action) {
      state.isDeleteUser = action.payload;
    },
    setIsEditUser(state, aciton) {
      state.isEditUser = aciton.payload;
    },
    setCurrentUserId(state, action) {
      state.userId = action.payload;
    },
    setUserCurrentTab(state, action) {
      state.currentTab = action.payload;
    },
  },
});

export const {
  setUserCurrentTab,
  setIsEditUser,

  setIsDeleteUser,
  setIsAddUser,
  setCurrentUserId,
} = userSlice.actions;

export default userSlice.reducer;
